const entitlements = {
    data: {
        "entitlements": [
            "#ru_counter_claim", "daily_claim", "daily_complete",
            // "cosmobutapr",
            // "cosmobut1_claimed_ent", "cosmobut1_completed_ent",
            // "cosmobut2_claimed_ent", "cosmobut2_completed_ent",
            // "cosmobut3_claimed_ent", "cosmobut3_completed_ent",
            // "cosmobut4_claimed_ent", "cosmobut4_completed_ent",
            // "cosmobut5_claimed_ent", "cosmobut5_completed_ent",
            // "cosmobut6_claimed_ent", "cosmobut6_completed_ent",
            // "cosmobut7_claimed_ent", "cosmobut7_completed_ent",
            // "cosmobut8_claimed_ent", "cosmobut8_completed_ent",
            // "cosmobut9_claimed_ent", "cosmobut9_completed_ent",
            // "cosmobut10_claimed_ent", "cosmobut10_completed_ent",
            // "cosmobut11_claimed_ent", "cosmobut11_completed_ent",
            // "cosmobut12_claimed_ent", "cosmobut12_completed_ent",
            // "cosmobut13_claimed_ent", "cosmobut13_completed_ent",
            // "cosmobut14_claimed_ent", "cosmobut14_completed_ent",
            // "cosmobut15_claimed_ent", "cosmobut15_completed_ent",
            // "cosmobut16_claimed_ent", "cosmobut16_completed_ent",
            // "cosmobut17_claimed_ent", "cosmobut17_completed_ent",
            // "cosmobut18_claimed_ent", "cosmobut18_completed_ent"
        ]
    }
};

export default entitlements
